<template>
    <div class="container-detail">
        <div class="detail-header-buttons">
            <v-btn @click="back" style="width: auto !important" class="button-accept">
                <v-icon>mdi-chevron-left</v-icon>
                Вернуться к списку баннеров
            </v-btn>

            <v-btn @click="goToEdit" style="width: auto !important" class="button-action">
                Редактировать
            </v-btn>
        </div>

        <div class="detail-main">
            <div class="detail-main-first-container">
                <div class="first-container-box" v-if="banner && banner.title">
                    <div class="container-box-title">
                        Заголовок
                    </div>
                    <div class="container-box-text">
                        {{ banner.title }}
                    </div>
                </div>
                <div class="first-container-box" v-if="banner && banner.description">
                    <div class="container-box-title">
                        Описание
                    </div>
                    <div class="container-box-text">
                        {{ banner.description }}
                    </div>
                </div>
                <div class="first-container-box"
                    v-if="!banner?.isVisibleInNewAppVersion || banner?.isVisibleOnAndroid || banner?.isVisibleOnIos">
                    <div class="container-box-title">
                        Настройки баннера
                    </div>
                    <div class="container-box-text">
                        {{ !banner.isVisibleInNewAppVersion ? 'Отображать только на старых версиях' : '' }}
                    </div>
                    <div class="container-box-text">
                        {{ banner.isVisibleOnAndroid ? 'Отображать на Android' : '' }}
                    </div>
                    <div class="container-box-text">
                        {{ banner.isVisibleOnIos ? 'Отображать на IOS' : '' }}
                    </div>
                </div>
                <div class="first-container-box" v-if="banner && (banner.datePublishStart || banner.datePublishEnd)">
                    <div class="container-box-title" style="padding-bottom: 6px">
                        Период отображения баннера
                    </div>
                    <div class="container-box-text-list">
                        <div class="container-box-text-list-item" v-if="banner && banner.datePublishStart">
                            <div class="list-item-subtitle">
                                Начало публикации
                            </div>
                            <div class="list-item-text">
                                {{ banner.datePublishStart | moment("DD.MM.YYYY") }}
                            </div>
                        </div>
                        <div class="container-box-text-list-item" v-if="banner && banner.datePublishEnd">
                            <div class="list-item-subtitle">
                                Конец публикации
                            </div>
                            <div class="list-item-text">
                                {{ banner.datePublishEnd | moment("DD.MM.YYYY") }}
                            </div>
                        </div>

                    </div>
                </div>
                <div class="first-container-box" v-if="banner && banner.transition">
                    <div class="container-box-title">
                        Вид перехода
                    </div>
                    <div class="container-box-text">
                        <span v-if="banner && banner.transition && banner.transition.type == 'deeplink'">
                            Внутренний раздел
                        </span>
                        <span v-else-if="banner && banner.transition && banner.transition.type == 'page'">
                            Страница
                        </span>
                        <span
                            v-else-if="banner && banner.transition && banner.transition.type == 'file' && !banner.transition.path">
                            PDF файл
                        </span>
                        <span
                            v-else-if="banner && banner.transition && banner.transition.type == 'file' && banner.transition.path">
                            <v-icon>
                                mdi-file-pdf-box
                            </v-icon>

                            <a target="_blank" :href="banner.transition.path">PDF файл</a>
                        </span>

                        <span v-else-if="banner && banner.transition && banner.transition.type == 'url'">
                            Ссылка
                        </span>

                    </div>
                </div>
                <div class="first-container-box"
                    v-if="banner && banner.transition && banner.transition.type == 'url' && banner.transition.path">
                    <div class="container-box-title">
                        Ссылка
                    </div>
                    <div class="container-box-text">
                        <a target="_blank" :href="banner.transition.path">{{ banner.transition.path }}</a>

                    </div>
                </div>
                <div class="first-container-box"
                    v-if="banner && banner.transition && banner.transition.type == 'deeplink' && banner.appSection">
                    <div class="container-box-title">
                        Раздел выбранный для перехода
                    </div>
                    <div class="container-box-text">
                        {{ banner.appSection.name }}
                    </div>
                </div>
                <div class="first-container-box"
                    v-if="banner && banner.transition && banner.transition.type == 'page' && banner.transition.page">
                    <div class="container-box-title">
                        Страница
                    </div>
                    <div class="container-box-text">
                        {{ banner.transition.page.title }}
                    </div>
                </div>






            </div>
            <div class="detail-main-second-container">
                <div class="second-container-box">
                    <div class="container-box-title">
                        Фон баннера
                    </div>
                    <div class="container-box-text">
                        Нажмите на изображение, чтобы увидеть его в полном размере
                    </div>
                </div>

                <div>
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        Формат
                                    </th>
                                    <th class="text-left">
                                        Место отображенния
                                    </th>
                                    <th class="text-left">
                                        Для смартфонов
                                    </th>
                                    <th class="text-left">
                                        Для планшетов
                                    </th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr style="height: 60px;">
                                    <td class="text-left">Баннер</td>
                                    <td class="text-left">Отображается на главной странице, над слайдером с разделами
                                        «новости» и «события»</td>
                                    <td class="text-left">
                                        <img @click="openDialogImg(banner.smartphoneImage)" v-if="banner.smartphoneImage"
                                            class="table-img" :src="banner.smartphoneImage">
                                    </td>
                                    <td class="text-left">
                                        <img @click="openDialogImg(banner.tabletImage)" v-if="banner.tabletImage"
                                            class="table-img" :src="banner.tabletImage">
                                    </td>
                                </tr>



                            </tbody>
                        </template>
                    </v-simple-table>

                    <DialogImage v-model="dialogImg" :src="previewImage" />


                </div>


            </div>


        </div>
    </div>
</template>
<script>

export default {

    data: () => ({
        banner: {},
        dialogImg: false,
        previewImage: '',
        imageWidth: 0,

    }),
    methods: {
        openDialogImg(src) {
            this.previewImage = src
            this.dialogImg = true
        },
        back() {
            this.$router.push({ name: 'Banners', params: { selectedTicker: 1 } })
        },
        goToEdit() {
            this.$router.push({ name: 'HorizontalBannersEdit', params: { id: this.$route.params.id } })
        },
        getBanner() {
            this.$axios.get(this.$store.getters.apiAdminPanelV2 + '/banner', {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                },
                params: {
                    bannerId: this.$route.params.id
                }
            })
                .then(res => {
                    this.banner = res.data

                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        }
    },
    created() {
        this.getBanner()
    }
}
</script>
<style lang="scss" scoped>
.container-detail {
    box-sizing: border-box;
    padding: 40px !important;

    .detail-header-buttons {
        display: flex;
        justify-content: space-between;
        margin-bottom: 40px;
    }

    .detail-main {
        display: flex;
        justify-content: space-between;

        .detail-main-first-container {
            width: 48%;

            .first-container-box {

                margin-bottom: 40px;

                .container-box-title {
                    font-size: 24px;
                    font-weight: 600;

                }

                .container-box-text {
                    font-size: 18px;
                    font-weight: 400;

                }

                .container-box-text-list {
                    .container-box-text-list-item {
                        display: flex;
                        margin-bottom: 5px;

                        .list-item-subtitle {
                            font-size: 16px;
                            font-weight: 600;
                            color: #929292;
                            width: 200px;
                        }

                        .list-item-text {
                            font-size: 18px;
                            font-weight: 400;
                        }

                    }
                }
            }
        }

        .detail-main-second-container {
            width: 48%;

            .table-img {
                cursor: pointer;
                height: 38px;
                object-fit: contain;
            }

            .second-container-box {
                width: 100%;
                margin-bottom: 40px;

                .container-box-title {
                    font-size: 24px;
                    font-weight: 600;

                }

                .container-box-text {
                    font-size: 18px;
                    font-weight: 400;

                }
            }
        }

    }
}
</style>